import type { RouteLocationNormalized } from 'vue-router';

import activeAuthServiceRegistry from '@rygen/rygen-ui/service/ActiveAuthServiceRegistry';

export default async (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
): Promise<boolean | string> => {
  let shouldProceed: boolean;
  if (to.meta?.requiresAuthn) {
    shouldProceed = await isAuthenticated();
  } else {
    shouldProceed = true;
  }

  return shouldProceed;
};

export async function isAuthenticated(): Promise<boolean> {
  try {
    await activeAuthServiceRegistry.getInstance().handleRedirectPromise();
  } catch (e) {
    // error already logged, so do nothing. Empty catch because we do want to proceed on failure.
  }

  try {
    await activeAuthServiceRegistry.getInstance().beginSession();
    return true;
  } catch (e) {
    console.warn('User not authenticated, initiating login', e);
    await activeAuthServiceRegistry.getInstance().login();
    return true;
  }
}
